import React from 'react';
import styled from 'styled-components';
import StringFormatter from '../utils/StringFormatter';
const Image = ({ onClick, ...rest }) => {
    const { alt = '', altParameters, styleContainer = true, className } = rest;
    // TODO ADD I18N HERE
    const outputText = StringFormatter(alt, altParameters);
    return React.createElement(ImageContainer, { className: styleContainer ? className : "", title: outputText, onClick: onClick },
        React.createElement(ImageContent, { ...rest, alt: outputText }));
};
const ImageContainer = styled.div ``;
const ImageContent = styled.img `
  margin: 0;
  padding: 0;
  border: 0;
  
  width: ${props => props.width};
  height: ${props => props.height};
  
  /* NOTE: This is a hack to remove image outline before the source is loaded */
  :not([src]) {
    visibility: hidden;
  }
`;
export default Image;
//# sourceMappingURL=Image.js.map